if (document.readyState === "loading") {
    // Calls the function during the 'DOMContentLoaded' event, after the HTML document has been completely loaded
    document.addEventListener("DOMContentLoaded", function () {
        initializeGoogleMaps();
    });
} else {
    // Calls the function directly in cases where the widget is rendered dynamically after 'DOMContentLoaded' has occurred
    initializeGoogleMaps();
}

function initializeGoogleMaps() {
    // timeout needs to be set so when we are in page builder mode so the Widget IFrames have sufficient time to load before the Google Maps script fires.
    buildGoogleMapsScript();
}

function buildGoogleMapsScript() {
    var mapContainers = $('.js-googleMapContainer');
    // only add the Google Maps API script to the page if it contains a mapped point widget
    if (mapContainers.length > 0) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "//maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyAjbprOH5NvCl1_jkTp3BrNEGVSDbQkWhk&callback=initializeAllMaps";
        document.body.appendChild(script);
    }
}

function initializeAllMaps() {
    var mapContainers = $('.js-googleMapContainer');
    initializeMapContainers(mapContainers);
}

function initializeSingleMap(mapId) {
    if (typeof google === 'object' && typeof google.maps === 'object') {
        var mapContainers = $('.js-googleMapContainer[data-id="' + mapId + '"]');
        initializeMapContainers(mapContainers);
    }
}

function initializeMapContainers(mapContainers) {
    mapContainers.each(function () {
        var $this = $(this);
        var id = $this.attr('data-id');
        var mapDiv = $this.find('.js-googleMap');
        var mapJson = $this.find('input').val();
        var map = JSON.parse(mapJson);

        var $section = $this.parents('.js-section');
        var $body = $('body');
        var mapStyles = [];
        if($body.hasClass('js-film-page')){
            mapStyles = [
                {
                    "featureType": "administrative",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "100"
                        },
                        {
                            "lightness": "1"
                        },
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#FAF3EA"
                        },
                        {
                            "weight": "0.01"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "off"
                        },
                        {
                            "color": "#FAF3EA"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "off"
                        },
                        {
                            "color": "#FAF3EA"
                        },
                        {
                            "saturation": "45"
                        },
                        {
                            "lightness": "-64"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "hue": "#ff0000"
                        },
                        {
                            "visibility": "off"
                        },
                        {
                            "saturation": "100"
                        },
                        {
                            "lightness": "-50"
                        },
                        {
                            "gamma": "1.60"
                        },
                        {
                            "weight": "0.01"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#4a335a"
                        },
                        {
                            "weight": "0.01"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative.country",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "saturation": "100"
                        },
                        {
                            "lightness": "9"
                        },
                        {
                            "weight": "6.25"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative.neighborhood",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#4a335a"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#F5ECFE"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "hue": "#ff0000"
                        },
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.terrain",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "hue": "#8000ff"
                        },
                        {
                            "saturation": "-80"
                        },
                        {
                            "lightness": "-75"
                        },
                        {
                            "gamma": "4.55"
                        },
                        {
                            "weight": "0.01"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#655C6E"
                        },
                        {
                            "saturation": "-30"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#655C6E"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "hue": "#9600ff"
                        },
                        {
                            "saturation": "100"
                        },
                        {
                            "lightness": "-71"
                        },
                        {
                            "weight": "5.35"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        },
                        {
                            "color": "#4a335a"
                        },
                        {
                            "saturation": "18"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#4a335a"
                        },
                        {
                            "saturation": "100"
                        },
                        {
                            "lightness": "-55"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.bus",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#e40000"
                        },
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#DFD6E8"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ];
        }else if ($section.hasClass('-blue') || $section.hasClass('-bluetext')) {
            mapStyles = [{ "stylers": [{ "hue": "#72A7D7" }, { "saturation": 650 }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "lightness": 50 }, { "visibility": "simplified" }] }, { "featureType": "road", "elementType": "labels", "stylers": [{ "visibility": "off" }] }];
        } else {
            mapStyles = [{ "stylers": [{ "hue": "#BF3919" }, { "saturation": 650 }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "lightness": 50 }, { "visibility": "simplified" }] }, { "featureType": "road", "elementType": "labels", "stylers": [{ "visibility": "off" }] }];
        }
        var mapCenter = map.MapCenter;
        var mappedPointItems = map.MappedPoints;
        var bounds = new google.maps.LatLngBounds();
        var zoomLevel = parseInt(map.MapZoomLevel);
        var mapOptions = {
            center: mapCenter,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: mapStyles
        };

        if (zoomLevel > 0) {
            mapOptions.zoom = zoomLevel;
        }

        // Display a map on the page
        map = new google.maps.Map(mapDiv[0], mapOptions);

        // Display multiple markers on a map
        var infoWindow = new google.maps.InfoWindow(), marker, i;

        // Loop through our array of markers & place each one on the map
        for (i = 0; i < mappedPointItems.length; i++) {
            var position = mappedPointItems[i].Coordinates;

            marker = new google.maps.Marker({
                position: position,
                map: map
            });

            if (zoomLevel == 0) {
                bounds.extend(position);
            }

            // Allow each marker to have an info window
            google.maps.event.addListener(marker,
                'click',
                (function (marker, i) {
                    return function () {
                        var infoWindowMarkup = "";
                        if (mappedPointItems[i].Title && mappedPointItems[i].Title.length > 0) {
                            infoWindowMarkup = infoWindowMarkup + "<h4>" + mappedPointItems[i].Title + "</h4>";
                        }
                        if (mappedPointItems[i].Description && mappedPointItems[i].Description.length > 0) {
                            infoWindowMarkup = infoWindowMarkup + "<p>" + mappedPointItems[i].Description + "</p>";
                        }
                        if (mappedPointItems[i].Url && mappedPointItems[i].Url.length > 0) {
                            infoWindowMarkup = infoWindowMarkup + "<p><a href='" + mappedPointItems[i].Url + "'>More Info</a></p>";
                        }
                        infoWindow.setContent(infoWindowMarkup);
                        infoWindow.open(map, marker);
                    }
                })(marker, i));
        }

        if (zoomLevel == 0) {
            // Automatically center the map fitting all markers on the screen
            map.fitBounds(bounds);
        }
    });
}